import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-p-2 child-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldConditions = _resolveComponent("FieldConditions")!
  const _component_DialogDelete = _resolveComponent("DialogDelete")!
  const _component_FieldConditionsForm = _resolveComponent("FieldConditionsForm")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_FieldConditions, {
        fieldConditions: _ctx.fieldConditions,
        loading: _ctx.loading,
        showErrorMessage: _ctx.showValidationMessage,
        onOnClickDelete: _ctx.openDeleteDialog,
        onOnEntrySelect: _ctx.onEntrySelect,
        documentClassFields: _ctx.documentClassFields,
        operators: _ctx.operators
      }, null, 8, ["fieldConditions", "loading", "showErrorMessage", "onOnClickDelete", "onOnEntrySelect", "documentClassFields", "operators"])
    ]),
    _createVNode(_component_DialogDelete, {
      showDialog: _ctx.deleteDialog,
      onOnClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteDialog = false)),
      onOnConfirm: _ctx.deleteEntry
    }, null, 8, ["showDialog", "onOnConfirm"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showDialog,
      onOnClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDialog = false, _ctx.isValidationInvalid = true, _ctx.showValidationMessage = false)),
      onOnConfirm: _ctx.saveEntry,
      loading: _ctx.loadingDialog,
      headerText: _ctx.headerText,
      showKeepDialogOpen: !_ctx.fieldCondition.id
    }, {
      content: _withCtx(() => [
        _createVNode(_component_BlockUI, { blocked: _ctx.loadingDialog }, {
          default: _withCtx(() => [
            _createVNode(_component_FieldConditionsForm, {
              ref: "fieldConditionsForm",
              fieldCondition: _ctx.fieldCondition,
              onUpdate: _ctx.onUpdate,
              showErrorMessage: _ctx.showValidationMessage,
              operators: _ctx.operators,
              documentClassFields: _ctx.documentClassFields
            }, null, 8, ["fieldCondition", "onUpdate", "showErrorMessage", "operators", "documentClassFields"])
          ]),
          _: 1
        }, 8, ["blocked"])
      ]),
      _: 1
    }, 8, ["show", "onOnConfirm", "loading", "headerText", "showKeepDialogOpen"])
  ], 64))
}